"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BaseAPIConfig = /** @class */ (function () {
    function BaseAPIConfig(protocol, server, app, api) {
        this.mProtocol = protocol;
        this.mServer = server;
        this.mApplication = app;
        this.mApi = api;
    }
    BaseAPIConfig.prototype.application = function () {
        return this.mApplication;
    };
    BaseAPIConfig.prototype.endPoint = function () {
        if (this.mApi) {
            return this.protocol() + "://" + this.server() + "/" + this.application() + "/" + this.mApi + "/";
        }
        else if (this.mApplication === "") {
            return this.protocol() + "://" + this.server() + "/";
        }
        else {
            return this.protocol() + "://" + this.server() + "/" + this.application() + "/";
        }
    };
    BaseAPIConfig.prototype.appEndPoint = function () {
        if (this.mApplication === "") {
            return this.protocol() + "://" + this.server() + "/";
        }
        else {
            return this.protocol() + "://" + this.server() + "/" + this.application() + "/";
        }
    };
    BaseAPIConfig.prototype.protocol = function () {
        return this.mProtocol;
    };
    BaseAPIConfig.prototype.server = function () {
        return this.mServer;
    };
    BaseAPIConfig.prototype.updateFromData = function (data) {
        if (data) {
            if (typeof data === "object") {
                updateSingleConfig(this, data, "protocol", "mProtocol");
                updateSingleConfig(this, data, "server", "mServer");
                updateSingleConfig(this, data, "application", "mApplication");
                updateSingleConfig(this, data, "api", "mApi");
                return true;
            }
            else if (typeof data === "string") {
                var p = parseUrl(data);
                if (p) {
                    this.mProtocol = p.protocol.replace(":", "");
                    this.mServer = p.host;
                    if (p.pathname) {
                        var parts = p.pathname.split("/").filter(function (x) {
                            return x != "";
                        });
                        if (parts.length >= 2) {
                            this.mApplication = parts[0];
                            this.mApi = parts.slice(1).join("/");
                        }
                        else if (parts.length == 1) {
                            this.mApplication = parts[0];
                            this.mApi = "";
                        }
                        else {
                            this.mApplication = "";
                            this.mApi = "";
                        }
                    }
                    else {
                        this.mApplication = "";
                        this.mApi = "";
                    }
                    return true;
                }
            }
        }
        return false;
    };
    return BaseAPIConfig;
}());
exports.BaseAPIConfig = BaseAPIConfig;
function updateSingleConfig(sink, source, key, objectKey) {
    if (objectKey === undefined)
        objectKey = key;
    if (source.hasOwnProperty(key)) {
        // @ts-ignore
        sink[objectKey] = source[key];
    }
}
var regUrlX = new RegExp([
    '^(https?:)//',
    '(([^:/?#]*)(?::([0-9]+))?)',
    '(/{0,1}[^?#]*)',
    '(\\?[^#]*|)',
    '(#.*|)$' // hash
].join(''));
function parseUrl(url) {
    var match = url.match(regUrlX);
    return match && {
        href: url,
        protocol: match[1],
        host: match[2],
        hostname: match[3],
        port: match[4],
        pathname: match[5],
        search: match[6],
        hash: match[7]
    };
}
exports.parseUrl = parseUrl;
